<div class="row pt-4 mb-5">
    <div class="col-md-5">
        <div class="card p-3 mb-4">
            <form role="form" [formGroup]="formCadastroEleitores" (ngSubmit)="envioEleitor()">
                <h5 *ngIf="!editandoEleitor" class="my-2">Cadastro de eleitores</h5>
                <h5 *ngIf="editandoEleitor" class="my-2">Edição de eleitores</h5>
                <hr>
                <div class="form-group">
                    <strong for="loginEleitor">Login *</strong>
                    <input type="text"
                        (blur)="validarLoginEleitor($event.target.value)"
                        class="form-control" 
                        name='loginEleitor'
                        id="loginEleitor"
                        formControlName="loginEleitor" 
                        placeholder="Digite o login do eleitor" 
                        [readonly]="!podeEditarEleitor"
                    required>
                </div>
                <div class="form-group">
                    <strong for="senhaEleitor">Senha *</strong>
                    <input type="password"
                        (blur)="validarSenhaEleitor($event.target.value)"
                        class="form-control"
                        name='senhaEleitor'
                        id="senhaEleitor"
                        formControlName="senhaEleitor"
                        placeholder="Digite a senha do eleitor" 
                    required>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-start bag">
                    <button class="btn btn-outline-secondary buttoncustom" (click)="gerarSenha()"><i class="fas fa-dice dicesmall"></i>Gerar senha</button>
                    <p class="ml-3 p-0 m-0"><strong>{{randomSenha}}</strong></p>
                </div>
                <div *ngIf="validaSenha == true" class="form-group">
                    <strong for="confirmarSenhaEleitor">Confirmar Senha</strong>
                    <input type="password"
                        (blur)="validarConfirmaSenhaEleitor($event.target.value)"
                        class="form-control"
                        name="confirmarSenhaEleitor"
                        id="confirmarSenhaEleitor"
                        formControlName="confirmarSenhaEleitor"
                        placeholder="Confirme a senha do eleitor" 
                    required>
                </div>
                <div class="row form-group">
                    <div class="col-12">
                    <strong for="auth1">Informação Autenticação 1 *</strong>
                    <input type="text"
                        (blur)="validarInformacoesAutenticacao(1)"
                        class="form-control" 
                        name='auth1'
                        id="auth1"
                        formControlName="auth1" 
                        placeholder="Digite a primeira Informação de Autenticação" 
                        [readonly]="!podeEditarEleitor"
                    required>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12">
                    <strong for="auth2">Informação Autenticação 2 *</strong>
                    <input type="text"
                        (blur)="validarInformacoesAutenticacao(2)"
                        class="form-control" 
                        name='auth2'
                        id="auth2"
                        formControlName="auth2" 
                        placeholder="Digite a segunda Informação de Autenticação" 
                        [readonly]="!podeEditarEleitor"
                    required>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <strong for="emailEleitor">Email</strong>
                            <input type="text"
                                (blur)="validarEmailEleitor($event.target.value)"
                                class="form-control" 
                                name='emailEleitor'
                                id="emailEleitor"
                                formControlName="emailEleitor" 
                                placeholder="Digite o email do eleitor">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-7">
                        <div class="form-group">
                            <strong for="plano">Plano</strong>
                            <input type="text"
                                class="form-control" 
                                name='plano'
                                id="plano"
                                formControlName="plano" 
                                placeholder="Digite o plano do eleitor"
                                [readonly]="!this.podeEditarEleitor">
                        </div>
                    </div>
                    <div class="col-7">
                        <div class="form-group">
                            <strong for="agrupador">Agrupador</strong>
                            <input type="text"
                                class="form-control" 
                                name='agrupador'
                                id="agrupador"
                                formControlName="agrupador" 
                                placeholder="Digite o agrupador do eleitor"
                                [readonly]="!this.podeEditarEleitor">
                        </div>
                    </div>
                    <div class="col-5" >
                        <div class="form-group">
                            <strong for="uf">UF</strong>
                            <select class="form-control" formControlName="estado" id="estado" [(ngModel)]="model.estado">
                            <option selected [disabled]="!podeEditarEleitor" [ngValue]="null" >Selecione</option>
                                <option  *ngFor="let u of ufs" [value] = "u.value" [disabled]="!podeEditarEleitor">
                                    {{u.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <button *ngIf="!editandoEleitor" [disabled]="btOff" type="submit" class="btn btn-success btn-custom">Salvar</button>
                <button *ngIf="editandoEleitor" [disabled]="btOff" type="submit" class="btn btn-success btn-custom">Salvar edição</button>
                <button *ngIf="editandoEleitor" (click)="cancelarEdicao()" type="button" class="btn btn-light btn-custom mr-2">Cancelar edição</button>
            </form>
        </div>
    </div>
    <div class="col-md-7">
        <div class="card p-3"  style="position: relative;">
            <div *ngIf="carregandoEleitores == true" class="carregando">
                <div class="c-loader"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
                <h5 class="mb-0 mr-auto">Eleitores</h5> 
                <div class="justify-items-end">
                    <button class="btn mr-2 btn-light ml-auto" (click)="baixarTemplate()" pTooltip="Baixar modelo de importação">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button class="btn btn-success ml-auto" data-toggle="modal" data-target="#modalcsv" pTooltip="Importar eleitores">
                        <i class="fas fa-file-csv"></i>
                    </button>
                </div>
            </div>
            <hr>
            <div class="input-group mb-3">
                <input type="text" class="form-control" id="filtroEleitor" placeholder="Digite o login do eleitor para buscar">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" style="font-size:15px!important;" (click)="filtrarEleitoresPorNome()"><i class="fas fa-search"></i></button>
                </div>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" style="font-size:15px!important;" (click)="limparFiltro()"><i class="fas fa-eraser"></i></button>
                  </div>
            </div>         
            <table class="table table-bordered">
                
                <thead>
                    <tr>
                        <th style="width: 90%;">Login</th>
                        <th class="text-center" colspan="2">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let eleitor of eleitores">
                        <td>{{eleitor.login}}</td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="editar" (click)="editarEleitor(eleitor)">
                                <i class="fas fa-edit fa-sm"></i>
                            </button>
                        </td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="excluir" (click)="excluirEleitor(eleitor.id)" [disabled]="btOff">
                                <i class="fas fa-trash fa-xs"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination [page]="page" (paginationEvent)=changePage($event)></pagination>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal fade" id="modalcsv"  #content>
    <app-massa-eleitor></app-massa-eleitor>
</div>